<script>
import {Bar} from 'vue-chartjs'
import actions from '@/utils/defines/actions.js';

export default {
  extends: Bar,
  props: ['eventCountsByActionTypeByDay', 'percentageMode'],
  mixins: [actions],
  computed: {
    chartData: function() {
      return {
        labels: this.labels,
        datasets: this.datasets
      }
    },
    labels: function() {
      return Object.keys(this.eventCountsByActionTypeByDay).sort();
    },
    datasets: function() {
      const count = this.actionTypesPresent.length;
      const that = this;
      return this.actionTypesPresent.map(function(action, index) {
        let alpha = 1 - (index * (1/count));
        let color = `rgba(0,156,225, ${alpha})`;

        if(action.type == '_unknown') {
          color = 'rgba(0,0,0,0.1)';
        }
        return {
          label: that.$t(action.name),
          borderColor: color,
          borderWidth: 1.5,
          backgroundColor: color,
          pointRadius: 0,
          pointHitRadius: 4,
          pointHoverBackgroundColor: color,
          data: that.countsForEvent(action.type)
        }
      })
    },
    options() {
      return {
        legend: {
          position: "bottom"
        },
        tooltips: {
          mode: 'x-axis',
          intersect: false,
          position: 'nearest'
        },
        hover: {
          mode: 'x-axis',
          intersect: false
        },
        scales: {
          xAxes: [{
            stacked: true,
            gridLines: {
              display: false
            },
            ticks: {
              fontColor: "#999",
            }
          }],
          yAxes: [{
            stacked: true,
            ticks: {
              min: 0,
              max: this.percentageMode ? 100 : undefined,
              fontColor: "#999"
            }
          }]
        },
        responsive: true,
        maintainAspectRatio: false,
        spanGaps: true,
        elements: {
          line: {
            tension: 0
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      };
    },
    actionTypesPresent: function() {
      let actionTypeTotals = { };
      for (let date of this.labels) {
        for (let actionType of Object.keys(this.eventCountsByActionTypeByDay[date])) {
          if (!actionTypeTotals[actionType]) {
            actionTypeTotals[actionType] = 0;
          }
          actionTypeTotals[actionType] += this.eventCountsByActionTypeByDay[date][actionType];
        }
      }
      return this.actions.filter(a => actionTypeTotals[a.type] > 0)
    }
  },
  mounted() {
    this.renderChart(this.chartData,this.options);
  },
  methods: {
    countsForEvent: function(action) {
      if (this.percentageMode) {
        return this.labels.map(date => {
          const total = Object.values(this.eventCountsByActionTypeByDay[date]).reduce((a,v)=>a+=v,0);
          if (total === 0) return 0;
          return Math.round((this.eventCountsByActionTypeByDay[date][action]||0)/total*10000)/100;
        });
      } else {
        return this.labels.map(date => {
          return this.eventCountsByActionTypeByDay[date][action] || 0;
        });
      }
    }
  },
  watch : {
    eventCountsByActionTypeByDay: function() {
      this.renderChart(this.chartData, this.options)
    },
    percentageMode: function() {
      this.renderChart(this.chartData, this.options)
    }
  }
}
</script>
